export const generateSlug = (text) => {
  return text
    .toLowerCase()
    .replaceAll(" ", "-")
    .replaceAll("&", "and")
    .replaceAll("%", "percentage").replaceAll("?", '').replaceAll(',', '').replaceAll('!','');
};
